import { useQuery } from 'urql';
import { getMetaAdsByAdSet } from '../graphql';
import type { GetMetaAdsByAdSetQuery, GetMetaAdsByAdSetQueryVariables } from '../../../../gql/social/graphql';

export const useAdsByAdSet = ({
  clientId,
  adSetIds,
  pause = false,
}: {
  clientId: string;
  adSetIds: string[];
  pause?: boolean;
}) => {
  const [{ data, fetching, error }] = useQuery<GetMetaAdsByAdSetQuery, GetMetaAdsByAdSetQueryVariables>({
    query: getMetaAdsByAdSet,
    variables: { clientId, adSetIds },
    pause: pause || !clientId || adSetIds.length === 0,
  });

  // Flatten ads from all ad sets across all campaigns and accounts
  const allAds =
    data?.client?.metaAdAccounts?.flatMap(
      (account) =>
        account?.metaAdCampaigns?.flatMap(
          (campaign) =>
            campaign?.metaAdSets?.flatMap(
              (adSet) =>
                adSet?.metaAds?.map((ad) => ({
                  ...ad,
                  adSetId: adSet.id,
                  adSetName: adSet.name,
                })) || [],
            ) || [],
        ) || [],
    ) || [];

  return {
    data,
    fetching,
    error,
    ads: allAds.filter((ad) => ad?.id),
    adSetsWithAds:
      data?.client?.metaAdAccounts?.flatMap(
        (account) =>
          account?.metaAdCampaigns?.flatMap((campaign) => campaign?.metaAdSets?.filter((adSet) => adSet?.id) || []) ||
          [],
      ) || [],
  };
};
